import { ref, onMounted, inject } from '@vue/composition-api'
import useRouter from '../useRouter'
import useErrors from '../useErrors'
import { cpRequestUtils } from '../../utils';


const useOwner = (campaigns, partnerSpots) => {

    const selectedCampaign = ref(null)
    const { route } = useRouter();

    const errorHandler = useErrors();

    onMounted(() => {
        if(!campaigns){
            return;
        }
        const preselect = route.value.query.preselected || (
            campaigns.length === 1 && campaigns[0].id
        )

        if (preselect) {
            const campaign = campaigns.find(
                campaign => campaign.id === preselect
            )

            if (campaign) {
                setCamp(campaign)
            }
        }
    })

    const setCamp = async campaign => {
        selectedCampaign.value = campaign
        const alreadyRequested = partnerSpots && cpRequestUtils.isAlreadyRequestedDate(partnerSpots, campaign.id)
        errorHandler.setError('already-requested-partner', alreadyRequested);
        errorHandler.setError('pick-your-campaign', false)
    }

    return {
        selectedCampaign,
        setCamp,
    }
}

export default useOwner